import { CacheKey } from '~/enums/cache'

export const currentLocal = getLocal(CacheKey.LOCAL_LANGUAGE, 'en')
